import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router";
import { Helmet } from "react-helmet-async";
// components
import BaseMap from "src/components/BaseMap/BaseMap";
// config
import { RESPONSE_STATUS } from "src/config/service";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

type Props = {
  children: ReactNode;
};

const MapLayout = ({ children }: Props) => {
  const dispatch = useDispatch();
  const trackingData = useSelector((state: any) => state.app.trackingData);

  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const optionalParamValue = urlParams.get("reset");
  useEffect(() => {
    if (optionalParamValue)
      dispatch(appActions.setOptionalParam(optionalParamValue));
  }, [optionalParamValue]);

  useEffect(() => {
    if (trackingData.serviceStatus === RESPONSE_STATUS.VERIFY) {
      navigate("../../verify");
    }
  }, [trackingData.serviceStatus]);

  useEffect(() => {
    if (window.innerWidth < 600) dispatch(appActions.setMobileMode(true));
    else dispatch(appActions.setMobileMode(false));
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) dispatch(appActions.setMobileMode(true));
      else dispatch(appActions.setMobileMode(false));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <Helmet>
        <title>GISimplify</title>
      </Helmet>
      <BaseMap>{children}</BaseMap>
    </>
  );
};
export default MapLayout;
